export const PREDEFINED_INDUSTRIES = [
    "Agriculture & Agritech",
    "Automotive",
    "Aviation & Aerospace",
    "Banking & Financial Services",
    "Biotechnology",
    "Construction & Infrastructure",
    "Consumer Electronics",
    "Consumer Goods (FMCG)",
    "Defense & Security",
    "E-commerce & Marketplace",
    "Education & EdTech",
    "Energy & Utilities",
    "Entertainment & Media",
    "FinTech",
    "Food & Beverage",
    "Gaming & Esports",
    "Healthcare & HealthTech",
    "Hospitality & Tourism",
    "Information Technology (IT)",
    "Insurance",
    "Logistics & Supply Chain",
    "Manufacturing",
    "Marketing & Advertising",
    "Mining & Metals",
    "Pharmaceuticals",
    "Real Estate",
    "Renewable Energy",
    "Retail",
    "SaaS & Software",
    "Telecommunications",
    "Textiles & Apparel",
    "Transportation & Mobility",
    "Warehousing",
    "Web3 & Blockchain",
    "Commercial Real Estate",
    "Residential Real Estate",
    "Industrial Assets",
    "Renewable Energy Projects",
    "Solar Power Projects",
    "Wind Energy Projects",
    "Technology Startups",
    "AI & Machine Learning",
    "FinTech Platforms",
    "Healthcare Ventures",
    "Infrastructure Projects",
    "Retail Business Assets",
    "Hospitality Projects",
    "Manufacturing Units",
    "Logistics Parks",
    "Warehousing Projects",
    "Franchise Business",
    "Pre-Leased Assets",
    "MSME Businesses",
    "Other"
];

export const PREDEFINED_CITIES = [
    "Mumbai",
    "Delhi",
    "Bangalore",
    "Hyderabad",
    "Ahmedabad",
    "Chennai",
    "Kolkata",
    "Surat",
    "Pune",
    "Jaipur",
    "Lucknow",
    "Kanpur",
    "Nagpur",
    "Indore",
    "Thane",
    "Bhopal",
    "Visakhapatnam",
    "Pimpri-Chinchwad",
    "Patna",
    "Vadodara",
    "Ghaziabad",
    "Ludhiana",
    "Agra",
    "Nashik",
    "Faridabad",
    "Meerut",
    "Rajkot",
    "Kalyan-Dombivli",
    "Vasai-Virar",
    "Varanasi",
    "Srinagar",
    "Aurangabad",
    "Dhanbad",
    "Amritsar",
    "Navi Mumbai",
    "Allahabad",
    "Ranchi",
    "Howrah",
    "Coimbatore",
    "Jabalpur",
    "Gwalior",
    "Vijayawada",
    "Jodhpur",
    "Madurai",
    "Raipur",
    "Kota",
    "Guwahati",
    "Chandigarh",
    "Solapur",
    "Hubli-Dharwad",
    "Mysore",
    "Tiruchirappalli",
    "Bareilly",
    "Aligarh",
    "Tiruppur",
    "Gurgaon",
    "Moradabad",
    "Jalandhar",
    "Bhubaneswar",
    "Salem",
    "Warangal",
    "Mira-Bhayandar",
    "Jalgaon",
    "Guntur",
    "Thiruvananthapuram",
    "Bhiwandi",
    "Saharanpur",
    "Gorakhpur",
    "Bikaner",
    "Amravati",
    "Noida",
    "Jamshedpur",
    "Bhilai",
    "Cuttack",
    "Firozabad",
    "Kochi",
    "Nellore",
    "Bhavnagar",
    "Dehradun",
    "Durgapur",
    "Asansol",
    "Rourkela",
    "Nanded",
    "Kolhapur",
    "Ajmer",
    "Akola",
    "Gulbarga",
    "Jamnagar",
    "Ujjain",
    "Loni",
    "Siliguri",
    "Jhansi",
    "Ulhasnagar",
    "Jammu",
    "Sangli-Miraj & Kupwad",
    "Mangalore",
    "Erode",
    "Belgaum",
    "Ambattur",
    "Tirunelveli",
    "Malegaon",
    "Gaya",
    "Tirupati",
    "Udaipur",
    "Kakinada",
    "Davanagere",
    "Kozhikode",
    "Maheshtala",
    "Rajpur Sonarpur",
    "Rajahmundry",
    "Bokaro",
    "South Dumdum",
    "Bellary",
    "Patiala",
    "Gopalpur",
    "Agartala",
    "Bhagalpur",
    "Muzaffarnagar",
    "Bhatpara",
    "Panihati",
    "Latur",
    "Dhule",
    "Rohtak",
    "Sagar",
    "Korba",
    "Bhilwara",
    "Berhampur",
    "Muzaffarpur",
    "Ahmednagar",
    "Mathura",
    "Kollam",
    "Avadi",
    "Kadapa",
    "Kamarhati",
    "Sambalpur",
    "Bilaspur",
    "Shahjahanpur",
    "Satara",
    "Bijapur",
    "Kurnool",
    "Rampur",
    "Shimoga",
    "Chandrapur",
    "Junagadh",
    "Thrissur",
    "Alwar",
    "Bardhaman",
    "Kulti",
    "Kakinada",
    "Nizamabad",
    "Parbhani",
    "Tumkur",
    "Khammam",
    "Ozhukarai",
    "Bihar Sharif",
    "Panipat",
    "Darbhanga",
    "Bally",
    "Aizawl",
    "Dewas",
    "Ichalkaranji",
    "Karnal",
    "Bathinda",
    "Jalna",
    "Eluru",
    "Barasat",
    "Kirari Suleman Nagar",
    "Purnia",
    "Satna",
    "Mau",
    "Sonipat",
    "Farrukhabad",
    "Durg",
    "Imphal",
    "Ratlam",
    "Hapur",
    "Arrah",
    "Anantapur",
    "Karimnagar",
    "Etawah",
    "Ambarnath",
    "North Dumdum",
    "Bharatpur",
    "Begusarai",
    "New Delhi",
    "Gandhidham",
    "Baranagar",
    "Tiruvottiyur",
    "Pondicherry",
    "Sikar",
    "Thoothukudi",
    "Rewa",
    "Mirzapur",
    "Raichur",
    "Pali",
    "Ramagundam",
    "Silchar",
    "Haridwar",
    "Vijayanagaram",
    "Tenali",
    "Nagercoil",
    "Sri Ganganagar",
    "Karawal Nagar",
    "Mango",
    "Thanjavur",
    "Bulandshahr",
    "Uluberia",
    "Katni",
    "Sambhal",
    "Singrauli",
    "Nadiad",
    "Secunderabad",
    "Naihati",
    "Yamunanagar",
    "Bidhan Nagar",
    "Pallavaram",
    "Bidar",
    "Munger",
    "Panchkula",
    "Burhanpur",
    "Raurkela Industrial Township",
    "Kharagpur",
    "Dindigul",
    "Gandhinagar",
    "Hospet",
    "Nangloi Jat",
    "Malda",
    "Ongole",
    "Deoghar",
    "Chapra",
    "Haldia",
    "Khandwa",
    "Nandyal",
    "Morena",
    "Amroha",
    "Anand",
    "Bhind",
    "Bhalswa Jahangir Pur",
    "Madhyamgram",
    "Bhiwani",
    "Berhampore",
    "Ambala",
    "Morbi",
    "Fatehpur",
    "Raebareli",
    "Khora",
    "Chittoor",
    "Bhusawal",
    "Orai",
    "Bahraich",
    "Vellore",
    "Mehsana",
    "Raiganj",
    "Sirsa",
    "Danapur",
    "Serampore",
    "Sultan Pur Majra",
    "Guna",
    "Jaunpur",
    "Panvel",
    "Shivpuri",
    "Surendranagar Dudhrej",
    "Unnao",
    "Chinsurah",
    "Alappuzha",
    "Kottayam",
    "Machilipatnam",
    "Shimla",
    "Adoni",
    "Udupi",
    "Katihar",
    "Proddatur",
    "Mahbubnagar",
    "Saharsa",
    "Dibrugarh",
    "Jorhat",
    "Hazaribagh",
    "Hindupur",
    "Nagaon",
    "Sasaram",
    "Hajipur",
    "Giridih",
    "Bhimavaram",
    "Kumbakonam",
    "Bongaigaon",
    "Dehri",
    "Madanapalle",
    "Siwan",
    "Bettiah",
    "Ramgarh",
    "Tinsukia",
    "Guntakal",
    "Srikakulam",
    "Motihari",
    "Dharmavaram",
    "Gudivada",
    "Phagwara",
    "Pudukkottai",
    "Hosur",
    "Narasaraopet",
    "Suryapet",
    "Miryalaguda",
    "Tadipatri",
    "Karaikudi",
    "Kishanganj",
    "Jamalpur",
    "Ballia",
    "Kavali",
    "Tadepalligudem",
    "Amaravati",
    "Buxar",
    "Tezpur",
    "Jehanabad",
    "Aurangabad",
    "Gangtok",
    "Phusro",
    "Other"
];

export const PREDEFINED_STATES = [
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chhattisgarh",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
    "Andaman and Nicobar Islands",
    "Chandigarh",
    "Dadra and Nagar Haveli and Daman and Diu",
    "Delhi",
    "Jammu and Kashmir",
    "Ladakh",
    "Lakshadweep",
    "Puducherry"
];
